import { FiAlertTriangle, FiRefreshCw } from "react-icons/fi";

const ErrorComponent = ({ message = "Something went wrong!", onRetry }) => {
    return (
        <div className="flex flex-col items-center justify-center text-center p-6 bg-red-50 border border-red-200 rounded-2xl shadow-sm">
            {/* Icon */}
            <div className="flex items-center justify-center w-14 h-14 bg-red-100 text-red-600 rounded-full mb-3">
                <FiAlertTriangle size={28} />
            </div>

            {/* Message */}
            <p className="text-red-700 font-medium mb-4">{message}</p>

            {/* Retry Button */}
            {onRetry && (
                <button
                    onClick={onRetry}
                    className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-colors"
                >
                    <FiRefreshCw size={18} />
                    <span>Retry</span>
                </button>
            )}
        </div>
    );
};

export default ErrorComponent;
